import React from 'react';
import './ExcelReviewTable.css';

function buildSkipMatrix(data, merges) {
  const skip = Array(data.length).fill(0).map(() =>
    Array(data[0]?.length || 0).fill(false)
  );
  merges.forEach(m => {
    for (let r = m.s.r; r <= m.e.r; r++) {
      for (let c = m.s.c; c <= m.e.c; c++) {
        if (!(r === m.s.r && c === m.s.c)) {
          skip[r][c] = true;
        }
      }
    }
  });
  return skip;
}

function getMergeInfo(merges, row, col) {
  for (const m of merges) {
    if (m.s.r === row && m.s.c === col) {
      return { rowSpan: m.e.r - m.s.r + 1, colSpan: m.e.c - m.s.c + 1 };
    }
  }
  return null;
}

const ExcelReviewTable = ({ headers, data, merges, filename, cellStyles = [] }) => {
  // Gộp headers và data thành mảng bảng đầy đủ
  const tableData = headers.length ? [headers, ...data] : data;
  if (!tableData.length) {
    return <div className="excel-preview-empty">Excel Data Not Found</div>;
  }
  // Tìm số cột lớn nhất
  const maxCol = Math.max(...tableData.map(row => row.length));
  const skipCell = buildSkipMatrix(tableData, merges);

  return (
    <div className="excel-preview-container">
      <div className="excel-preview-title">{filename}</div>
      <div className="excel-preview-scroll">
        <table className="excel-preview-table">
          <thead>
            <tr>
              {/* Cột số thứ tự */}
              <th
                style={{
                  border: '1px solid #e3e8ef',
                  padding: 6,
                  background: '#ffffffff',
                  fontWeight: 700,
                  textAlign: 'center',
                  width: 48,
                  minWidth: 36,
                }}
              >
                {/* Để trống, không có chữ No. */}
              </th>
              {headers.map((h, i) => (
                <th
                  key={i}
                  style={{
                    border: '1px solid #e3e8ef',
                    padding: 6,
                    background: '#ffffffff',
                    fontWeight: 700,
                    textAlign: 'center',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rIdx) => (
              <tr key={rIdx}>
                {/* Số thứ tự in đậm */}
                <td
                  style={{
                    border: '1px solid #e3e8ef',
                    padding: 6,
                    textAlign: 'center',
                    background: '#ffffffff',
                    fontWeight: 700,
                  }}
                >
                  {rIdx + 1}
                </td>
                {row.map((cell, cIdx) => {
                  // Lấy style cho ô này nếu có
                  const style = cellStyles?.[rIdx]?.[cIdx] || {};
                  return (
                    <td
                      key={cIdx}
                      style={{
                        border: '1px solid #e3e8ef',
                        padding: 6,
                        textAlign: 'left',
                        ...style,
                      }}
                    >
                      {cell}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExcelReviewTable;
